import {ChangeDetectionStrategy, Component, inject, input, OnInit} from '@angular/core';
import {DeclarationFile} from "../../types/declaration-modal.types";
import {DeclarationFilesStateService} from "../../services/declaration-files-state.service";
import {
  AttachProductCardFileParams,
  DeleteFileParams,
  GetFilesParams
} from "../../../../../types/product-card-files.types";
import {declarationFilesResourceType} from "../../configs/declaration-modal-config";
import {DeclarationModalService} from "../../services/declaration-modal.service";
import {LoadingService} from "../../../../../../../../core/services/loading.service";
import {AttachFileParams} from "../../../../../../../../core/types/file.types";
import {FileCardComponent} from "../../../../../../../../shared/components/ui/file-card/file-card.component";
import {
  FileUploadCardComponent
} from "../../../../../../../../shared/components/ui/file-upload-card/file-upload-card.component";

@Component({
  selector: 'div[app-declaration-files]',
  imports: [
    FileCardComponent,
    FileUploadCardComponent
  ],
  templateUrl: './declaration-files.component.html',
  styleUrl: './declaration-files.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeclarationFilesComponent implements OnInit {
  declarationId = input<number>(0);
  isEditModeActive = input<boolean>(false);

  private declarationFilesStateService: DeclarationFilesStateService = inject(DeclarationFilesStateService);
  private declarationModalService: DeclarationModalService = inject(DeclarationModalService);
  private loadingService: LoadingService = inject(LoadingService);

  public async ngOnInit(): Promise<void> {
    await this.getFiles();
  }

  public getFilesById(): Array<DeclarationFile> {
    return this.declarationFilesStateService.getDeclarationFilesById(this.declarationId());
  }

  public async handleDelete(isImage: boolean, file: DeclarationFile):  Promise<void> {
    const deleteFileParams: DeleteFileParams = {
      path: declarationFilesResourceType.path,
      id: file.id
    };

    this.declarationModalService.deleteFile(deleteFileParams)
      .then(() => this.declarationFilesStateService.deleteFileById(file.id, this.declarationId()));
  }

  public async attachFile({ parentId, fileId }: AttachFileParams): Promise<void> {
    const attachFileParams: AttachProductCardFileParams = {
      path: declarationFilesResourceType.path,
      body: {
        fileId: fileId,
        declarationId: parentId
      }
    };

    await this.declarationModalService.attachFile<DeclarationFile>(attachFileParams)
      .then((data) => this.declarationFilesStateService.updateDeclarationFilesState(this.declarationId(), data));
  }

  private async getFiles(): Promise<void> {
    this.loadingService.setIsLoadingState(true);
    const params: GetFilesParams = {
      path: declarationFilesResourceType.path,
      params: { declarationId: this.declarationId() }
    };

    await this.declarationModalService.getFiles(params)
      .then((data) => this.declarationFilesStateService.setDeclarationFilesState(this.declarationId(), data))
      .finally(() => this.loadingService.setIsLoadingState(false));
  }
}
